<template>
  <!-- 退付信息弹窗 -->
  <div>
    <van-popup v-model="showModel" round :close-on-click-overlay="false">
      <div class="content">
        <div class="ti">
          退费账户
          <div class="close" @click="closeDialog">×</div>
        </div>
        <div
          :style="
            refundItem.refundStatus == '1'
              ? 'padding: 10px 20px'
              : 'padding: 0px 20px'
          "
          class="cBox"
        >
          <div
            class="cont"
            v-if="refundItem.refundStatus == '0'"
            v-html="content"
          ></div>
          <div>
            <van-form ref="formPhone1">
              <!-- 退费记录代码 -->
              <div class="phoneBox">
                <div class="phLabel">考生姓名</div>
                <van-field
                  v-model="loginForm.payer"
                  type="text"
                  maxlength="50"
                  label=""
                  disabled
                  placeholder="请输入考生姓名"
                />
              </div>
              <div class="phoneBox">
                <div class="phLabel">考生收款银行</div>
                <van-field
                  :disabled="refundItem.refundStatus == '1'"
                  v-model="loginForm.receiveBank"
                  rows="1"
                  autosize
                  type="textarea"
                  maxlength="50"
                  label=""
                  :rules="[{ required: true }]"
                  placeholder="如:中国建设银行"
                />
              </div>
              <div class="phoneBox">
                <div class="phLabel">考生开户行支行名称</div>
                <van-field
                  rows="1"
                  autosize
                  type="textarea"
                  :disabled="refundItem.refundStatus == '1'"
                  v-model="loginForm.accountBank"
                  maxlength="50"
                  label=""
                  :rules="[{ required: true }]"
                  placeholder="如:重庆江北观音桥支行"
                />
              </div>
              <div class="phoneBox">
                <div class="phLabel">考生开户行卡号</div>
                <van-field
                  maxlength="19"
                  :disabled="refundItem.refundStatus == '1'"
                  v-model="loginForm.accountNumber"
                  type="number"
                  label=""
                  :rules="[{ required: true }]"
                  placeholder="务必填写准确"
                />
              </div>
              <div class="phoneBox" v-if="refundItem.refundStatus == '0'">
                <div class="phLabel">校验码</div>

                <van-field
                  class="phInput"
                  v-model="loginForm.captcha"
                  label=""
                  :rules="[{ required: true }]"
                  placeholder="填写校验码"
                  maxlength="6"
                />
                <img
                  class="captchaClass"
                  id="captcha"
                  :src="imageCode"
                  @click="getCaptcha()"
                />
              </div>
            </van-form>
          </div>
        </div>

        <!-- 未退费才允许编辑确定 -->
        <div class="butarea" v-if="refundItem.refundStatus == '0'">
          <van-button @click="confirmPay" class="confirm" round type="info"
            >确定</van-button
          >
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  props: {
    isShowDialog: {
      type: Boolean,
    },
    refundItem: {
      type: Object,
    },
  },
  created() {
    this.getCaptcha();
  },
  data() {
    return {
      imageCode: "",
      accountNumber: "", // 银行卡号
      accountBank: "", // 银行名称
      payer: "", // 缴款人
      showModel: false,
      detailData: [],
      detailList: [],
      curData: null,
      loginForm: {
        receiveBank: "",
        captchaKey: "",
        captcha: "",
        payer: "",
        accountNumber: "",
        accountBank: "",
      },
      options: [
        { label: "个人", value: "1" },
        { label: "单位", value: "2" },
      ],
      showType: false,
      payerType: "",
      payerTypeName: "",
      phone: "",
      defaultIndex: 0,
      content:
        '*请准确填写退款账户信息，"考生开户行支行名称"请填写全称，填写错误将影响退款。',
    };
  },
  watch: {
    isShowDialog: {
      deep: true,
      handler(newV, oldV) {
        if (newV) {
          this.showModel = true;
          // this.phone = this.checkArr[0].phone ? this.checkArr[0].phone : "";
          // this.payerType = this.checkArr[0].payerType
          //   ? this.checkArr[0].payerType
          //   : "";
          this.loginForm.accountNumber = this.refundItem.accountNumber
            ? this.refundItem.accountNumber
            : "";
          this.loginForm.accountBank = this.refundItem.accountBank
            ? this.refundItem.accountBank
            : "";
          this.loginForm.payer = this.refundItem.paymentUnit
            ? this.refundItem.paymentUnit
            : "";
          this.loginForm.receiveBank = this.refundItem.receiveBank
            ? this.refundItem.receiveBank
            : "";
          this.loginForm.captcha = "";
          document.body.style.position = "fixed";
          document.body.style.width = "100%";
          document.body.style.height = "100%";
          if (this.refundItem.refundStatus == "0") {
            this.getCaptcha();
          }
        } else {
          document.body.style.position = "static";
          document.body.style.height = "auto";
        }
      },
    },
  },
  methods: {
    // 图片验证码
    getCaptcha() {
      this.request({
        url: "/sso/captcha",
        method: "get",
      }).then((res) => {
        if (res.data.code == 1000) {
          this.imageCode = res.data.result.image;
          this.loginForm.captchaKey = res.data.result.captchaKey;
        }
      });
    },
    closeDialog() {
      this.showModel = false;
      this.$refs.formPhone1.resetValidation();
      this.$emit("closeRef");
    },
    confirmPay() {
      this.loginForm.accountBank = this.loginForm.accountBank.trim();
      this.loginForm.receiveBank = this.loginForm.receiveBank.trim();
      this.loginForm.accountNumber = this.loginForm.accountNumber.trim();
      this.loginForm.captcha = this.loginForm.captcha.trim();
      this.$refs.formPhone1
        .validate()
        .then(() => {
          let obj = {
            bizId: this.refundItem.uId,
            accountNumber: this.loginForm.accountNumber, // 银行卡号
            accountBank: this.loginForm.accountBank, // 银行名称
            payer: this.loginForm.payer, // 缴款人
            receiveBank: this.loginForm.receiveBank,
            captchaKey: this.loginForm.captchaKey,
            captcha: this.loginForm.captcha,
          };
          this.request({
            url: "/payBankAccountInput/refundAccountInput",
            method: "post",
            data: obj,
          }).then((res) => {
            if (res.data.code == 1000) {
              Toast.success(res.data.message);
              this.showModel = false;
              this.$emit("closeRef", "1");
            } else {
              this.$dialog
                .alert({
                  title: "提示",
                  message: res.data.message,
                })
                .then(() => {});
            }
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>

<style lang='scss' scoped>
.phoneBox {
  ::v-deep .van-field--disabled {
    background: #f5f7fa;
  }
  ::v-deep .van-field__control:disabled {
    color: #333 !important;
    -webkit-text-fill-color: #333 !important;
  }
  .phLabel {
    font-size: 14px;
  }
  ::v-deep .van-field__label {
    margin-right: 0px;
  }
  position: relative;
  > img {
    width: 14px;
    position: absolute;
    top: 16px;
    right: 10px;
  }
  .phInput {
    width: 63%;
  }
  .captchaClass {
    border: 1px solid #ebedf0;
    top: 18px;
    width: 87px;
    right: 0px;
  }
}
.billBox {
  position: relative;
  > img {
    width: 14px;
    position: absolute;
    top: 16px;
    right: 10px;
  }
}
.cBox {
  margin-top: 10px;
  max-height: 60vh;
  overflow-y: scroll;
  ::v-deep .van-cell {
    padding: 4px 10px;
    margin-top: 4px;
    border: 0.02667rem solid #ebedf0;
    margin-bottom: 12px;
  }
  ::v-deep .van-cell::after {
    border-bottom: none !important;
  }
  ::v-deep .van-field__control {
    // max-width: 90%;
    word-break: break-all;
  }
}
.notice {
  text-align: left;
  color: #f56c6c;
  line-height: 20px;
  padding: 0.1rem 0;
}
.cont {
  font-size: 14px;
  max-height: 186px;
  overflow-y: auto;
  padding: 10px 0px;
  padding-top: 0px;
  line-height: 24px;
  // padding-top: 20px;
  word-break: break-all;
  color: #f04f4f;
}
.ti {
  position: relative;
  text-align: center;
  // position: absolute;
  // top: 4%;
  // left: 50%;
  // z-index: 1001;
  // width: 86%;
  // transform: translateX(-50%); url("../assets/img/paybg.png")
  font-size: 16px;
  color: #fff;
  padding: 18px 0px;
  border-radius: 8px 8px 0px 0px;
  background: #1989fa;
  ::v-deep .van-divider {
    margin: 10px 0px !important;
    background: rgb(235, 235, 235) !important;
  }
}
.deta {
  display: flex;
  justify-content: space-between;
}
.showD {
  // position: fixed;
  // z-index: 1000;
  // height: 100vh;
  // width: 100vw;
  // background: rgba(0, 0, 0, 0.5);
  // top: 0%;
  // left: 50%;
  // transform: translateX(-50%);
}
.close {
  position: absolute;
  right: 20px;
  bottom: 10px;
  font-size: 30px;
  color: #fff;
  font-weight: 300;
}
.circle {
  width: 80px;
  height: 80px;
  background: #fff;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -30%);
  border-radius: 50%;
  z-index: -1;
}
.dialogTitle {
  .van-dialog__header {
    background: #1989fa;
    color: #fff;
    padding: 10px 0 !important;
    font-weight: 600 !important;
  }
}
.content {
  width: 80vw;

  // border-radius: 8px;
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // width: 72%;
  // max-height: 75%;
  // transform: translate(-50%, -50%);
  // background: #fff;
  // text-align: left;
  // line-height: 24px;
  // ::v-deep .van-divider {
  //   background: rgb(235, 235, 235) !important;
  // }
  ::v-deep .van-form {
    box-shadow: none !important;
  }
}

.butarea {
  display: flex;
  padding: 10px 6px;
  padding-bottom: 10px;
  justify-content: space-around;
  .cancel {
    width: 120px;
    height: 40px;
    color: #777 !important;
  }
  .confirm {
    width: 270px;
    height: 40px;
    color: #fff !important;
  }
}
</style>